import React from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { StyledFormContainer, StyledPaperContainer, StyledSectionTitle } from '../../PlusWebsiteEditor.styles';
import { PatientCommunicationChannel as IPatientCommunicationChannel, WebsiteConfiguration } from '../../types/websiteConfiguration';
import { FieldErrorGetter } from '../../types/handlers';
import { StyledErrorText } from '../../components/ImageUploader/ImageUploader.styles';

type Props = {
  communicationChannel: WebsiteConfiguration['communication_channel'];
  getError: FieldErrorGetter;
  onChange: (fieldName: string, value: string, shouldValidate?: boolean) => void;
};

const PatientCommunicationChannel = ({ communicationChannel, getError, onChange }: Props) => (
  <StyledPaperContainer>
    <StyledSectionTitle>Patient Communication Channel</StyledSectionTitle>
    <StyledErrorText>{getError()}</StyledErrorText>
    <StyledFormContainer>
      <RadioGroup
        name="communication_channel"
        onChange={(_, value) => onChange('communication_channel', value, true)}
        value={communicationChannel}
      >
        <FormControlLabel value={IPatientCommunicationChannel.HEALTHERA} control={<Radio />} label="Email & Text - Healthera" />
        <FormControlLabel value={IPatientCommunicationChannel.PARTNER} control={<Radio />} label="Webhook - Partner Integration" />
      </RadioGroup>
    </StyledFormContainer>
  </StyledPaperContainer>
);

export default PatientCommunicationChannel;
